<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-11 10:48:10
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-23 11:27:05
 * @FilePath: \合联\oms\src\view\finances\summary_bill\collect.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :row="params" ref="details"></Details>
    </template>
    <template #Email="{ visible, params }">
      <EmailDetails v-if="visible" :row="params.row"></EmailDetails>
    </template>
  </cTable>
</template>

<script>
import {
  getCollect,
  batchDelete,
  add,
  exportItem,
  previewEmail,
  sendEmail,
  details,
  adjustOff,
  getRates,
  setRates,
  confirm,
} from "@/api/finance/summary_bill";
import { getService } from "@/api/double/list";
import { getConfig } from "@/api/double/bill";
import { getAllClient } from "@/api/user/client";
import { getCurrency } from "@/api/finance/currency";
import cTable from "@/base/common/index";
import Details from "./details";
import EmailDetails from "./email_details";
import {searchCustomer} from "@/api/tracker/sea";

export default {
  name: "summary_bill",
  components: {
    cTable,
    Details,
    EmailDetails
  },
  data() {
    return {
      buffClientArray: [],
      methods: {
        list: getCollect,
        getService,
        getConfig,
        batchDelete,
        getAllClient,
        add,
        exportItem,
        previewEmail,
        sendEmail,
        details,
        adjustOff,
        getRates,
        setRates,
        confirm,
        beforeHandleList: ({ data }) => {
          this.fields = this.fields.filter(t => t.key != "all_currency");

          data.all_currency.length &&
            this.$nextTick(() => {
              this.fields.splice(2, 0, {
                key: "all_currency",
                name: () => this.$tz("费用"),
                children: data.all_currency.map(key => {
                  return {
                    name: () => key,
                    key: "finance_info." + key,
                    minWidth: 100
                  };
                })
              });
            });
          console.log(this.fields);
          return data.rows;
        }
      },
      modals: {
        rate: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("saveRates", data, false, true)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("rate"),
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle")
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              to_bill_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            {
              to_bill_currency: 24
            },
            {
              qar_to_rate: 24
            },
            {
              kwd_to_rate: 24
            },
            {
              cny_to_rate: 24
            },
            {
              usd_to_rate: 24
            },
            {
              aed_to_rate: 24
            },
            {
              sar_to_rate: 24
            },
            {
              bhd_to_rate: 24
            }
          ],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_bill_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code"
              },
              methods: {
                list({ field }) {
                  getCurrency().then(res => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                }
              }
            },
            {
              name: () => "QAR" + this.$t("Change Target Currency Rate"),
              key: "qar_to_rate",
              component: "InputNumber",
              placeholder: () => "QAR" + this.$t("Change Target Currency Rate"),
              required: true,
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "KWD" + this.$t("Change Target Currency Rate"),
              key: "kwd_to_rate",
              component: "InputNumber",
              placeholder: () => "KWD" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "CNY" + this.$t("Change Target Currency Rate"),
              key: "cny_to_rate",
              component: "InputNumber",
              placeholder: () => "CNY" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "USD" + this.$t("Change Target Currency Rate"),
              key: "usd_to_rate",
              component: "InputNumber",
              placeholder: () => "USD" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "AED" + this.$t("Change Target Currency Rate"),
              key: "aed_to_rate",
              component: "InputNumber",
              placeholder: () => "AED" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "SAR" + this.$t("Change Target Currency Rate"),
              key: "sar_to_rate",
              component: "InputNumber",
              placeholder: () => "SAR" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => "BHD" + this.$t("Change Target Currency Rate"),
              key: "bhd_to_rate",
              component: "InputNumber",
              placeholder: () => "BHD" + this.$t("Change Target Currency Rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            }
          ]
        },
        details: {
          config: {
            title: this.$tz("账单"),
            modalBind: {
              width: 1200
            }
          },
          header:{
            show:()=>true,
            methods:{
              confirm({field}){
                this.$Modal.confirm({
                  title: field.name(),
                  width: 300,
                  content: this.$t('titleModal'),
                  onOk: () => {
                    let params = field.type === 'confirm'?{
                      task_no:this.params.task_no,
                      ids:this.selectAll.map(t=>t.id)
                    }:{ adjust: this.selectAll.map(item => {
                    return {
                      id: item.id,
                      change_amount: item.change_amount,
                      remarks: item.remarks
                    };
                  }),task_no:this.params.task_no, }
                    this.$page.handleRequestMethods(field.type,params,true,true).then(
                      res => {
                        this.getList()
                      }
                    );
                  }
                })
              }
            },
            btns:[
              {
                name: () => this.$tz('批量,确认'),
                type: 'confirm',
                fnName: 'confirm',
                bind: {
                  type: 'primary'
                },
                disabled(){
                  return !this.selectAll.length
                }
              },
              {
                name: () => this.$tz('批量,核销'),
                type: 'adjustOff',
                fnName: 'confirm',
                bind: {
                  type: 'primary',
                  style:{
                    marginLeft:'10px'
                  }
                },
                disabled(){
                  return !this.selectAll.length
                }
              },
            ]
          },
          footer: {
            ok: {
              name: this.$tz("核销")
            },
            show() {
              return false
            }
          },
          table: {
            config: {
              height: 600,
              showOverflow: false
            },
            fields: [
              {
                type:'checkbox',
                width:50,
                align:'center'
              },
              {
                name: () => this.$tz("账单,类型"),
                key: "bill_type",
                minWidth: 110
              },
              {
                name: () => this.$tz("账单号"),
                key: "bill_number",
                minWidth: 110
              },
              {
                name: () => this.$tz("账单,名称"),
                key: "bill_name",
                minWidth: 110
              },
              {
                name: () => this.$tz("账单,金额"),
                key: "bill_amount",
                minWidth: 110,
                total: true
              },
              {
                name: () => this.$tz("账单,币种"),
                key: "bill_currency",
                minWidth: 110
              },
              {
                name: () => this.$tz("调账,金额"),
                key: "change_amount",
                minWidth: 110,
                component: "InputNumber",
                bind: {
                  size: "small"
                },
                disabled: ({ row }) => {
                  return row.origin.status == 9 || row.origin.status == "PAID";
                },
                methods: {
                  "on-change"({ row }) {
                    row.after_amount = parseFloat(
                      parseFloat(row.bill_amount) +
                        parseFloat(row.change_amount)
                    ).toFixed(2);
                  }
                },
                total: true
              },
              {
                name: () => this.$tz("实际,应收"),
                key: "after_amount",
                minWidth: 110
              },
              {
                name: () => this.$tz("备注"),
                key: "remarks",
                minWidth: 120,
                component: "Input",
                disabled: ({ row }) =>
                  row.origin.status == 9 || row.origin.status == "PAID",
                bind: {
                  size: "small",
                  type: "textarea",
                  autosize: { minRows: 1, maxRows: 3 }
                }
              },
              {
                name: () => this.$tz("结算状态"),
                key: "origin.status_txt",
                minWidth: 110
              }
            ]
          }
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("add", row, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ],
              start_time: [
                {
                  required: true,
                  type: "date",
                  trigger: "change"
                }
              ],
              end_time: [
                {
                  required: true,
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            { client_id: 24 },
            { name: 24 },
            { start_time: 24 },
            { end_time: 24 }
          ],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              // component: "Select",
              // placeholder: () => this.$t("select") + this.$t("clientName"),
              // options: [],
              // config: { label: "account", value: "id" },
              // methods: {
              //   async list({ field }) {
              //     field.options = (
              //       await this.$page.handleRequestMethods("getAllClient")
              //     ).payload.rows;
              //     this.$forceUpdate();
              //   }
              // }
              component: "SelectSearchable",
              placeholder: () => this.$t("select") + this.$t("clientName"),
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                'remote-method': ({fields}, query) => {
                  if (query.length >= 2) {
                    getAllClient({likeKeywords: query}).then(res => {
                      fields.find(vv => vv.key === 'client_id').options = res.data.payload.rows.map(vv => {
                        return {
                          account: vv.account,
                          id: vv.id
                        }
                      })
                    })
                  }
                }
              }
            },
            {
              name: () => this.$t("summary") + this.$t("bill_name"),
              key: "name",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("summary") + this.$t("bill_name")
            },
            {
              name: () => this.$t("start") + this.$t("time"),
              key: "start_time",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("date");
              },
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }
              },
              methods: {
                "on-change"({ row }) {
                  let data = JSON.parse(JSON.stringify(row));
                  data.start_time = data.start_time
                    ? this.$page.format.timeFormat(data.start_time)
                    : "";
                }
              }
            },
            {
              name: () => this.$t("end") + this.$t("time"),
              key: "end_time",
              placeholder() {
                return this.$t("select") + this.$t("end") + this.$t("time");
              },
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }
              }
            }
          ]
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 70
            }
          },
          header: {
            show: true,
            btns: [
              {
                name: () => this.$t("export"),
                key: "export",
                fnName: "export",
                bind: {
                  icon: "md-arrow-down",
                  type: "warning",
                  style: {
                    marginLeft: "5px"
                  }
                }
              }
            ],
            methods: {
              export: () => {
                this.$refs["details"].export();
              }
            }
          },
          footer: { show: () => false }
        },
        preview: {
          contentSlot: "Email",
          config: {
            modalBind: {
              // draggable: true,
              // transfer: true,
              width: 920
            }
          },
          header: {
            show: true,
            btns: [
              {
                name: () => this.$t("Chinese"),
                key: "ch-zn",
                type: "ch",
                fnName: "setLocale",
                bind: {
                  type: "default",
                  style: {
                    marginLeft: "5px"
                  }
                }
              },
              {
                name: () => this.$t("English"),
                key: "en-us",
                type: "en",
                fnName: "setLocale",
                bind: {
                  type: "primary",
                  style: {
                    marginLeft: "5px"
                  }
                }
              }
            ],
            methods: {
              async setLocale({ field, row, fields }) {
                fields.forEach(item => {
                  if (item.key == field.key) {
                    item.bind.type = "primary";
                  } else {
                    item.bind.type = "default";
                  }
                });
                this.$page.getModal("preview").params.row = {};
                let res = (
                  await this.$page.handleRequestMethods("previewEmail", {
                    id: row.id,
                    lang: field.key
                  })
                ).payload;
                res.id = row.id;
                res.lang = field.key;
                this.$page.getModal("preview").params.row = res;
                this.$forceUpdate();
              }
            }
          },
          footer: { show: () => false }
        },
        showLocal: {
          methods: {
            ok({ row, close }) {
              let data = {};
              if (this.type == "exportItem") data.id = row.id;
              if (this.type == "sendEmail") data.ids = [row.id];
              // console.log(this.type);
              // return;
              this.$page
                .handleRequestMethods(this.type, data, false, true)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.type == "exportItem" &&
                    window.open(this.$globalUrl + res.payload.src);
                  this.$page.getList();
                  close();
                });
              // this.$page.handleRequestMethods("add", row).then(res => {
              //   this.$Message["success"]({
              //     background: true,
              //     content: res.msg
              //   });
              //   this.$page.getList();
              //   close();
              // });
            }
          },
          config: {
            modalBind: {
              width: 400,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              lang: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ lang: 24 }],
          fields: [
            {
              name: () => this.$t("language"),
              key: "lang",
              component: "Radio",
              placeholder: () => this.$t("select") + this.$t("language"),
              options: [
                {
                  label: this.$t("Chinese"),
                  value: "zh-cn"
                },
                {
                  label: this.$t("English"),
                  value: "en-us"
                }
              ],
              default: "en-us",
              bind: {
                border: true
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "value",
          //     value: "key"
          //   }
          // },
          {
            key: "start_time",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.start_time = searchForm.start_time
                  ? this.$page.format.timeFormat(searchForm.start_time)
                  : "";
              }
            }
          },
          {
            key: "end_time",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.end_time);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.end_time = time;
                }
              }
            }
          },
          {
            key: "client_id",
            placeholder() {
              return '搜索客户名称';
            },
            component: "AutoComplete",
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              filterable: true
            },
            data: [],
            onSearch: ({value, item}) => {
              if (value.length >= 2) {
                searchCustomer(value).then(res => {
                  item.data = res.data.payload
                })
              }
            }
          },
          // {
          //   key: "sale_id",
          //   placeholder() {
          //     return this.$t("select") + this.$t("salesman");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label({ row }) {
          //       return row.realname
          //         ? row.account + "(" + row.realname + ")"
          //         : row.account;
          //     },
          //     value: "id"
          //   }
          // },
          // {
          //   key: "bill_status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("bill_type");
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "whether_usd",
          //   placeholder() {
          //     return this.$t("amount_receivable") + "(USD)是否0";
          //   },
          //   component: "Select",
          //   options: [
          //     { label: this.$t('YES'), value: "YES" },
          //     { label: this.$t('NO'), value: "NO" }
          //   ]
          // },
          // {
          //   key: "main_contract_header",
          //   placeholder() {
          //     return this.$t("select") + this.$t("contract_title");
          //   },
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field }) {
          //       field.options = (await getB2Bbill()).data.payload;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          // {
          //   key: "service_code",
          //   placeholder() {
          //     return this.$t("select") + this.$t("company");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "service_name",
          //     value: "service_code"
          //   }
          //   // methods: {
          //   //   async list({ field }) {
          //   //     let res = (await ()).data.payload;
          //   //     field.options = res;
          //   //     this.$forceUpdate();
          //   //   }
          //   // }
          // },
          // {
          //   key: "department",
          //   placeholder() {
          //     return this.$t("select") + this.$t("assistDepartment");
          //   },
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["CLEARANCE_DEPARTMENT"])).data
          //         .payload["CLEARANCE_DEPARTMENT"];
          //       field.options = res;
          //       this.$forceUpdate();
          //     }
          //   }
          // },

          // {
          //   key: "keywordsType",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("keywords_type");
          //   },
          //   clearable: false,
          //   options: [],
          //   methods: {
          //     list({ field, searchForm }) {
          //       this.$page
          //         .handleRequestMethods("getKeysType", "B2B_BILL_KEYWORDS")
          //         .then(res => {
          //           searchForm[field.key] = res.payload[0].value;
          //           field.options = res.payload;
          //         });
          //     }
          //   }
          // },
          {
            key: "bill_status",
            placeholder() {
              return this.$tz("结算状态");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "BILL_STATUS_TYPE"
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "ios-trash",
                type: "warning"
              }
            },
            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rate",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            }
            // {
            //   name: () => this.$t("pushClinet"),
            //   type: "pushClinet",
            //   fnName: "pushClinet",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
          ],
          methods: {
            rate() {
              let ids = this.selectAll.map(item => item.id);
              this.handleRequestMethods("getRates", {
                ids
              }).then(res => {
                res.payload.ids = ids;
                this.getModal("rate").config.rules = {
                  to_bill_currency: [
                    {
                      required: true,
                      message: "cannot be empty",
                      trigger: "blur"
                    }
                  ]
                };
                res.payload.required.map(t => {
                  this.getModal("rate").config.rules[
                    t.toLocaleLowerCase() + "_to_rate"
                  ] = [
                    {
                      required: true,
                      message: "cannot be empty",
                      trigger: "blur",
                      type: "number",
                      min: 0.01,
                      max: 9999999
                    }
                  ];
                });
                console.log(this.getModal("rate").config);
                this.getModal("rate").open(res.payload);
              });
            },
            // 导出
            export() {
              this.exportExc();
            },
            // 新增
            add() {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            },
            // 删除
            delete() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("batchDelete", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("clientName"),
          key: "client_account",
          minWidth: 100,
          fixed: "left",
          align: "left"
        },
        {
          name: () => this.$t("task_no"),
          key: "task_no",
          // component: this.$hasPermission(402) ? "Button" : "span",
          component: "Button",
          minWidth: 150,
          fixed: "left",
          copy: true,
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ row }) {
              return row.task_no;
            },
            click({ row }) {
              // if (!this.$hasPermission(402)) return;
              this.$page.getModal("showDetails").open(row, function() {
                this.setTitle(this.$t("task_no") + "(" + row.task_no + ")");
              });
            }
          }
        },
        {
          name: () => this.$t("total_amount"),
          key: "total_amount",
          width: 150
        },
        {
          name: () => this.$t("summary") + this.$t("bill_name"),
          key: "name",
          width: 150
        },
        {
          name: () => this.$tz("结算状态"),
          key: "bill_status_txt",
          minWidth: 110
        },
        {
          name: () => this.$t("bill1") + this.$t("start") + this.$t("time"),
          key: "start_time",
          width: 150
        },
        {
          name: () => this.$t("bill1") + this.$t("end") + this.$t("time"),
          key: "end_time",
          width: 150
        },
        // {
        //   name: () => this.$t("complete") + this.$t("time"),
        //   key: "done_time",
        //   width: 150
        // },
        // {
        //   name: () => this.$t("exlType"),
        //   key: "status_txt",
        //   width: 80
        // },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          minWidth: 100,
          align: "left"
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
            {
              name: () => this.$tz("账单"),
              type: "details",
              fnName: "details",
              bind: {
                type: "primary"
              }
            },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "warning"
              }
            },
            {
              name: this.$t("preview") + this.$t("email"),
              type: "preview",
              fnName: "preview",
              bind: {
                type: "success"
              }
            },
            {
              name: this.$t("send") + this.$t("email"),
              type: "send",
              fnName: "send",
              bind: {
                type: "error"
              },
              disabled: ({ row }) => {
                return row.bill_status == 9;
              }
            }
          ],
          methods: {
            details({ row }) {
              this.handleRequestMethods("details", row, false, true).then(
                res => {
                  this.getModal("details").open(row, function() {
                    this.setTitle(this.$t("账单"));
                    this.list = res.payload.map(t => {
                      return {
                        ...t.adjust,
                        order: t.order,
                        ...t
                      };
                    });
                  });
                }
              );
            },
            export({ row }) {
              this.getModal("showLocal").open(row, function() {
                this.setTitle(this.$t("language"));
                this.type = "exportItem";
              });
              // this.handleRequestMethods("exportItem", row.id, false, true).then(
              //   res => {
              //     window.open(this.$globalUrl + res.payload.src);
              //   }
              // );
            },
            async preview({ row }) {
              let res = (
                await this.handleRequestMethods("previewEmail", {
                  id: row.id,
                  lang: "en-us"
                })
              ).payload;
              res.id = row.id;
              res.lang = "en-us";
              res.bill_status = row.bill_status;
              this.getModal("preview").open({ row: res }, function() {
                this.setTitle(
                  row.task_no +
                    "(" +
                    this.$t("email") +
                    this.$t("preview") +
                    ")"
                );
              });
            },
            send({ row }) {
              this.getModal("showLocal").open(row, function() {
                this.setTitle(this.$t("language"));
                this.type = "sendEmail";
              });
              // this.$Modal.confirm({
              //   title: this.$t("whether") + this.$t("send") + this.$t("email"),
              //   width: 300,
              //   onOk: () => {
              //     this.handleRequestMethods("sendEmail", {
              //       ids: [row.id]
              //     }).then(res => {
              //       this.$Message["success"]({
              //         background: true,
              //         content: res.msg
              //       });
              //       // this.getList();
              //     });
              //   }
              // });
            }
          }
        }
      ]
    };
  },
  async created() {
    // let service = (await getService()).data.payload;
    let data = (await getConfig()).data.payload;
    // let client_id = (await getAllClient()).data.payload.rows;
    // let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    this.header.searchs.forEach(item => {
      if (item.key === "time_type") {
        item.options = data.time_type;
        this.$refs["table"].$refs["header"].searchForm["time_type"] =
          item.options[0].key;
      }
      // if (item.key === "bill_status")
      //   item.options = Object.keys(data.bill_status).map(item => ({
      //     value: item,
      //     label: data.bill_status[item]
      //   }));
      // if (item.key === "client_id") item.options = client_id;
      // if (item.key === "sale_id") item.options = salesman;
      // if (item.key === "service_code") item.options = service;
    });
  }
};
</script>
